export default [
  {
    path: '/overtime-data',
    name: 'overtime-data',
    component: () => import('@/views/pages/management/overtime-data/List.vue'),
    meta: {
      name: 'Data Lembur',
      resource: 'Management - Data Lembur',
      action: 'manage',
    },
  },
  {
    path: '/overtime-data/setting-approval-chain',
    name: 'overtime-data-setting-approval-chain',
    component: () => import('@/views/pages/management/overtime-data/SettingApprovalChain.vue'),
    meta: {
      name: 'Setting Approval Chain',
      navActiveLink: 'overtime-data',
      resource: 'Management - Data Lembur',
      action: 'manage',
    },
  },
]
